import React, { SVGProps } from 'react';

export const RightArrowIconAlt = ({
  width = 12,
  height = 11,
  fill = 'white',
  ...props
}: SVGProps<SVGSVGElement> & {
  width?: number;
  height?: number;
  fill?: string;
}): JSX.Element => (
  <svg width={width} height={height} viewBox='0 0 12 11' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M6.35221 10.48L5.13621 9.248L7.64821 6.72H0.512207V4.72H7.66421L5.12021 2.176L6.33621 0.959999L11.1042 5.712L6.35221 10.48Z'
      fill={fill}
    />
  </svg>
);
